// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2MmoF","errorLogs":"styles_errorLogs__X2sDY"};